import { useState, useEffect } from "react";

// Desktop (lg:+ / >=1024px) detector — drives the dual-pane desktop shell.
// Below lg the app behaves exactly like the mobile chassis (untouched).
export default function useIsDesktop() {
  const [d, setD] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
  );
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const on = () => setD(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return d;
}
